import { useSyncExternalStore } from 'react';
import AppDataManager from '../calling-cross-tab-utils/AppDataManager';
export const useConnectionStatus = () => {
  const connectionStatus = useSyncExternalStore(AppDataManager.subscribeToConnectionStatus, AppDataManager.getConnectionStatus);
  return connectionStatus;
};